<template>
    <div class="width100">
        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="2"></Aide>

        <h3 class="titreSolu text-center">Protocole de sécurité</h3>

        <h3 class="titreSolu text-center" >De quel site s'agit il?</h3>

        <br />

        <br />
        <br />
        <br />
        <div  class="row" style="overflow: scroll;height:250px;">
            <div v-for="(proto, keyProto) in listProto" :key="keyProto" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded">
                    <a v-if="proto" :href="proto.url" style="color:white" download="download" target="_blank">
                        {{proto.fileName}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Protocole",
        props: ['token', 'site', 'user', 'racine', 'listUser', 'userId', 'userType', 'idUser', 'systemeClient', 'systemeClientId'
            , 'ifAppli'],
        data() {
            return {
                aide: '', errors: [], listMachine: null, choix: 0, niveau: 1,
                fileName:null,
                listProto:null,
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            getListProtocole()
            {
                fetch(this.racine + this.site + 'api/get_liste_protocole/', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)

                    response.json().then(json => {
                        console.log(json)
                        this.listProto = json['listeProtocole']
                        console.log(this.listProto)
                    })
                })
            },
        },
        mounted() {
            console.log('gdfg')
            this.getListProtocole()
        }
    }
</script>


<style scoped>
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border: 2px white solid;
        font-size: 28px;
    }

    .listMachineNonCharge {
        font-size: 28px;
    }
    .afficheCarte
    {
        margin-bottom: 50px;
        border: 3px solid #0f6674;
    }
</style>